import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface EnvironmentContextType {
  showDevData: boolean;
  setShowDevData: (value: boolean) => void;
}

const EnvironmentContext = createContext<EnvironmentContextType | undefined>(undefined);

export function EnvironmentProvider({ children }: { children: ReactNode }) {
  const [showDevData, setShowDevData] = useState(() => {
    if (typeof window === 'undefined') return false;
    const stored = localStorage.getItem('show-dev-data');
    return stored === 'true';
  });

  useEffect(() => {
    localStorage.setItem('show-dev-data', String(showDevData));
  }, [showDevData]);

  return (
    <EnvironmentContext.Provider value={{ showDevData, setShowDevData }}>
      {children}
    </EnvironmentContext.Provider>
  );
}

export function useEnvironment() {
  const context = useContext(EnvironmentContext);
  if (!context) {
    throw new Error('useEnvironment must be used within EnvironmentProvider');
  }
  return context;
}
